/** Tiny history router: `/`, `/link`, `/link#c=<code>`, `/settings`. */
import { useSyncExternalStore } from 'react';

export type Route =
  | { name: 'voice' }
  | { name: 'link'; code: string | null }
  | { name: 'settings' };

export function parseRoute(pathname: string, hash: string): Route {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/settings' || path === '/impostazioni') return { name: 'settings' };
  if (path === '/link' || path.startsWith('/link/')) {
    // Chat link: /link#c=<code> (fragment: never sent to servers or in Referer); /link/<code> tolerated.
    const fromHash = new URLSearchParams(hash.replace(/^#/, '')).get('c');
    const fromPath = path.startsWith('/link/') ? decodeURIComponent(path.slice('/link/'.length)) : null;
    return { name: 'link', code: fromHash || fromPath || null };
  }
  return { name: 'voice' };
}

const listeners = new Set<() => void>();
let current = typeof window !== 'undefined' ? window.location.pathname + window.location.hash : '/';

function emit() {
  current = window.location.pathname + window.location.hash;
  for (const l of listeners) l();
}

if (typeof window !== 'undefined') window.addEventListener('popstate', emit);

export function navigate(path: string, opts: { replace?: boolean } = {}): void {
  if (opts.replace) window.history.replaceState(null, '', path);
  else window.history.pushState(null, '', path);
  emit();
}

/** Removes the code from the address bar (history.replaceState, §7.1). */
export function scrubLinkCode(): void {
  window.history.replaceState(null, '', '/link');
  current = '/link';
}

export function useLocationKey(): string {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
